<template>
  <DeepHeader />
  <NewModal
    isOpen
    absolute
    :class="{ [$style.noBorder]: !isValidRoom }"
  >
    <JoinLesson
      v-if="!isValidRoom && isInitialized"
      v-model:link="link"
      :error="error"
      :isLoading="isLoading"
      @join="joinLesson"
    />

    <template v-if="isValidRoom && isInitialized">
      <DeepLinkContent
        :text="text"
        :title="title"
      />
      <DeepLinkButton
        :deepLink="deepLink"
        :isAppInstalled="isAppInstalled"
        :isCheckSupported="isCheckSupported"
        :text="!isCheckSupported ? 'deepLink.joinLesson': ''"
      />
      <StoreButton
        v-if="!isAppInstalled || !isCheckSupported"
        :secondary="!isCheckSupported"
      />
    </template>
  </NewModal>
</template>

<script setup>
import DeepLinkButton from '@/deepLinks/components/DeepLinkButton.vue';
import DeepLinkContent from '@/deepLinks/components/DeepLinkContent.vue';
import { computed, onBeforeMount, ref } from 'vue';
import StoreButton from '@/deepLinks/components/StoreButton/StoreButton.vue';
import NewModal from '@/shared/components/Modal/NewModals/NewModal.vue';
import JoinLesson from '@/deepLinks/components/JoinLesson.vue';
import { useRoute, useRouter } from 'vue-router';
import { useCheckRoom } from '@/deepLinks/hooks/useCheckRoom';
import { useCheckProtocol } from '@/deepLinks/hooks/useCheckProtocol';
import DeepHeader from '@/deepLinks/components/DeepHeader.vue';
import { purifyLink } from '@/deepLinks/purifyLink';

const route = useRoute();
const router = useRouter();
const link = ref(purifyLink(location.href));
const isValidRoom = ref(false);
const isLoading = ref(true);
const isInitialized = ref(false);

const { isCheckSupported, isAppInstalled, deepLink, checkProtocol } = useCheckProtocol({ isInitialized, link });
const { error, checkRoom } = useCheckRoom({ isLoading, link, isValidRoom });

const title = computed(() => {
  if (isAppInstalled.value) {
    return 'deepLink.room';
  }

  if (!isAppInstalled.value && isCheckSupported.value) {
    return 'deepLink.studentTitle';
  }

  if (!isCheckSupported.value) {
    return 'deepLink.notSupportedCheck';
  }

  return null;
});

const text = computed(() => {
  if (!isAppInstalled.value && isCheckSupported.value) {
    return 'deepLink.notInstalledApp';
  }

  return null;
});

const joinLesson = async () => {
  const roomId = await checkRoom();

  if (!roomId) {
    isInitialized.value = true;
    return;
  }

  await router.replace({
    name: route.name,
    params: {
      id: roomId,
    },
  });

  link.value = location.href;
  isValidRoom.value = true;

  checkProtocol();

  isInitialized.value = true;
};

onBeforeMount(joinLesson);

</script>

<style lang="scss" module>

.title {
  color: $color-primary;
  @include H3;
  text-align: center;
}

.noBorder > div {
  border: none;
}
</style>
